module.exports = __webpack_public_path__ + "img/logo_shine_medical_couleur_noir.61893d37.png";